"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return AccessPaid;
    }
});
var _react = /*#__PURE__*/ _interopRequireWildcard(require("react"));
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
        return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
        return {
            default: obj
        };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
        return cache.get(obj);
    }
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj){
        if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) {
                Object.defineProperty(newObj, key, desc);
            } else {
                newObj[key] = obj[key];
            }
        }
    }
    newObj.default = obj;
    if (cache) {
        cache.set(obj, newObj);
    }
    return newObj;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function AccessPaid(_param) {
    var title = _param.title, props = _objectWithoutProperties(_param, [
        "title"
    ]);
    return /*#__PURE__*/ _react.createElement("svg", _extends({
        width: "40",
        height: "40",
        viewBox: "0 0 40 40",
        fill: "currentColor",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": !!title
    }, props), title ? /*#__PURE__*/ _react.createElement("title", null, title) : null, /*#__PURE__*/ _react.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M6.36763 25.1288C8.47111 24.1961 12.2859 23 18 23C19.0972 23 20.1223 23.043 21.0783 23.1181L22.0752 23.1963L21.9187 25.1902L20.9217 25.1119C20.0177 25.041 19.0448 25 18 25C12.5746 25 9.03557 26.1337 7.1789 26.9569M6.36763 25.1288C4.91901 25.7722 4 27.2075 4 28.783ZM7.1789 26.9569C7.05242 27.0131 6.93388 27.0815 6.82442 27.1605C6.31315 27.5295 6 28.1286 6 28.783V33H21V35H5L4 34V28.783",
        fill: "currentColor"
    }), /*#__PURE__*/ _react.createElement("path", {
        d: "M18 23C12.2859 23 8.47111 24.1961 6.36763 25.1288C4.91901 25.7722 4 27.2075 4 28.783V34L5 35H21V33H6V28.783C6 28.1286 6.31315 27.5295 6.82442 27.1605C6.93388 27.0815 7.05242 27.0131 7.1789 26.9569C9.03557 26.1337 12.5746 25 18 25C19.0448 25 20.0177 25.041 20.9217 25.1119L21.9187 25.1902L22.0752 23.1963L21.0783 23.1181C20.1223 23.043 19.0972 23 18 23Z",
        fill: "currentColor"
    }), /*#__PURE__*/ _react.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M18 7C14.6863 7 12 9.68629 12 13C12 16.3137 14.6863 19 18 19C21.3137 19 24 16.3137 24 13C24 9.68629 21.3137 7 18 7ZM10 13C10 8.58172 13.5817 5 18 5C22.4183 5 26 8.58172 26 13C26 17.4183 22.4183 21 18 21C13.5817 21 10 17.4183 10 13Z",
        fill: "currentColor"
    }), /*#__PURE__*/ _react.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M29 35V37H31V35H33C34.6569 35 36 33.6569 36 32V31C36 29.3431 34.6569 28 33 28H31V25H35V23H31V21H29V23H27C25.3431 23 24 24.3431 24 26V27C24 28.6569 25.3431 30 27 30H29V33H24V35H29ZM31 33H33C33.5523 33 34 32.5523 34 32V31C34 30.4477 33.5523 30 33 30H31V33ZM29 28V25H27C26.4477 25 26 25.4477 26 26V27C26 27.5523 26.4477 28 27 28H29Z",
        fill: "currentColor"
    }));
}

//# sourceMappingURL=AccessPaid.js.map